/** @format */
import React, { useState } from 'react'
import { Form, FormItem } from '@king-design/react'
import { FormItemLabelToopltip, ProductGroupSelect } from 'src/components'
import ApiCommon from 'src/api/ApiCommon'
import request from './utils/request'
import { useAsync } from 'react-use'

export const tags = ['aaa', 'bbb', 'ccc', 'ddd', 'eee', 'fff', 'ggg']
export const unmatch_instances = [
  {
    instanceId: '0cb81d20-a169-44a3-9812-dd59e86f1437',
    instanceName: 'CG-CS-GAME-15',
    instanceIP: '10.22.2.43',
    region: 'cn-qingyangtest-1',
    metricKey: 'rx.bytes.phy',
    metricTags: [],
    selectedMetricTags: [],
    unselectedMetricTags: ['p1=eth0x', 'p1=eth1x', 'p1=eth2x', 'p1=eth3x', 'p1=eth4x']
  },
  {
    instanceId: 'd7c2a187-a503-4413-b36d-43c9b837a076',
    instanceName: 'CG-CS-GAME-19',
    instanceIP: '10.22.2.23',
    region: 'cn-qingyangtest-1',
    metricKey: 'rx.bytes.phy',
    metricTags: [],
    selectedMetricTags: [],
    unselectedMetricTags: ['p1=eth0x', 'p1=eth1x', 'p1=eth2x', 'p1=eth3x', 'p1=eth4x']
  },
  {
    instanceId: '39520275-ddce-406d-a514-4f24af054c1e',
    instanceName: 'CG-CS-GAME-22',
    instanceIP: '10.22.2.98',
    region: 'cn-qingyangtest-1',
    metricKey: 'rx.bytes.phy',
    metricTags: [],
    selectedMetricTags: [],
    unselectedMetricTags: ['p1=eth0x', 'p1=eth1x', 'p1=eth2x', 'p1=eth3x', 'p1=eth4x']
  },
  {
    instanceId: '92fec73f-b208-45de-9076-f3c981171019',
    instanceName: 'CG-CS-GAME-33',
    instanceIP: '10.22.2.153',
    region: 'cn-qingyangtest-1',
    metricKey: 'rx.bytes.phy',
    metricTags: [],
    selectedMetricTags: [],
    unselectedMetricTags: ['p1=eth0x', 'p1=eth1x', 'p1=eth2x', 'p1=eth3x', 'p1=eth4x']
  },
  {
    instanceId: '3279d8b4-9126-48f3-adfd-fb77ec7073c8',
    instanceName: 'CG-CS-GAME-17',
    instanceIP: '10.22.2.186',
    region: 'cn-qingyangtest-1',
    metricKey: 'rx.bytes.phy',
    metricTags: [],
    selectedMetricTags: [],
    unselectedMetricTags: ['p1=eth0x', 'p1=eth1x', 'p1=eth2x', 'p1=eth3x', 'p1=eth4x']
  },
  {
    instanceId: 'd794aa56-5fde-45c4-876e-28aaf2a075e6',
    instanceName: 'CG-CS-GAME-30',
    instanceIP: '10.22.2.149',
    region: 'cn-qingyangtest-1',
    metricKey: 'rx.bytes.phy',
    metricTags: [],
    selectedMetricTags: [],
    unselectedMetricTags: ['p1=eth0x', 'p1=eth1x', 'p1=eth2x', 'p1=eth3x', 'p1=eth4x']
  },
  {
    instanceId: '0a18c094-253e-4e9b-9fb7-04c32998eb94',
    instanceName: 'CG-CS-GAME-24',
    instanceIP: '10.22.2.175',
    region: 'cn-qingyangtest-1',
    metricKey: 'rx.bytes.phy',
    metricTags: [],
    selectedMetricTags: [],
    unselectedMetricTags: ['p1=eth0x', 'p1=eth1x', 'p1=eth2x', 'p1=eth3x', 'p1=eth4x']
  },
  {
    instanceId: '45b4d627-6ad1-4c35-b43f-500e205fd5ef',
    instanceName: 'CG-CS-GAME-27',
    instanceIP: '10.22.2.12',
    region: 'cn-qingyangtest-1',
    metricKey: 'rx.bytes.phy',
    metricTags: [],
    selectedMetricTags: [],
    unselectedMetricTags: ['p1=eth0x', 'p1=eth1x', 'p1=eth2x', 'p1=eth3x', 'p1=eth4x']
  },
  {
    instanceId: '01758e5a-a31f-48ad-9bbd-bc238da0de7e',
    instanceName: 'CG-CS-GAME-20',
    instanceIP: '10.22.2.181',
    region: 'cn-qingyangtest-1',
    metricKey: 'rx.bytes.phy',
    metricTags: [],
    selectedMetricTags: [],
    unselectedMetricTags: ['p1=eth0x', 'p1=eth1x', 'p1=eth2x', 'p1=eth3x', 'p1=eth4x']
  },
  {
    instanceId: '47311138-e0ed-4308-8197-2f136d79a962',
    instanceName: 'CG-CS-GAME-13',
    instanceIP: '10.22.2.97',
    region: 'cn-qingyangtest-1',
    metricKey: 'rx.bytes.phy',
    metricTags: [],
    selectedMetricTags: [],
    unselectedMetricTags: ['p1=eth0x', 'p1=eth1x', 'p1=eth2x', 'p1=eth3x', 'p1=eth4x']
  },
  {
    instanceId: 'b4dc54f7-9542-48db-b33b-b671d858fea2',
    instanceName: 'CG-CS-GAME-34',
    instanceIP: '10.22.2.73',
    region: 'cn-qingyangtest-1',
    metricKey: 'rx.bytes.phy',
    metricTags: [],
    selectedMetricTags: [],
    unselectedMetricTags: ['p1=eth0x', 'p1=eth1x', 'p1=eth2x', 'p1=eth3x', 'p1=eth4x']
  },
  {
    instanceId: '8ad2670d-86d7-4087-8a5b-9ab9925bb9f8',
    instanceName: 'CG-CS-GAME-26',
    instanceIP: '10.22.2.10',
    region: 'cn-qingyangtest-1',
    metricKey: 'rx.bytes.phy',
    metricTags: [],
    selectedMetricTags: [],
    unselectedMetricTags: ['p1=eth0x', 'p1=eth1x', 'p1=eth2x', 'p1=eth3x', 'p1=eth4x']
  },
  {
    instanceId: '34aa44bf-7b67-465f-8f5d-0fbfc6e7b9d4',
    instanceName: 'CG-CS-GAME-35',
    instanceIP: '10.22.2.179',
    region: 'cn-qingyangtest-1',
    metricKey: 'rx.bytes.phy',
    metricTags: [],
    selectedMetricTags: [],
    unselectedMetricTags: ['p1=eth0x', 'p1=eth1x', 'p1=eth2x', 'p1=eth3x', 'p1=eth4x']
  },
  {
    instanceId: 'dc4e8f58-ea81-4adb-b8a6-8cf89b555dbe',
    instanceName: 'CG-CS-GAME-55',
    instanceIP: '10.22.2.207',
    region: 'cn-qingyangtest-1',
    metricKey: 'rx.bytes.phy',
    metricTags: [],
    selectedMetricTags: [],
    unselectedMetricTags: ['p1=eth0x', 'p1=eth1x', 'p1=eth2x', 'p1=eth3x', 'p1=eth4x']
  },
  {
    instanceId: '3642f8f6-d95d-4aad-8324-148374e47c8f',
    instanceName: 'CG-CS-GAME-36',
    instanceIP: '10.22.2.237',
    region: 'cn-qingyangtest-1',
    metricKey: 'rx.bytes.phy',
    metricTags: [],
    selectedMetricTags: [],
    unselectedMetricTags: ['p1=eth0x', 'p1=eth1x', 'p1=eth2x', 'p1=eth3x', 'p1=eth4x']
  },
  {
    instanceId: 'd0aec36f-7d7f-4e32-9732-c0b56f2b8cbc',
    instanceName: 'CG-CS-GAME-39',
    instanceIP: '10.22.2.133',
    region: 'cn-qingyangtest-1',
    metricKey: 'rx.bytes.phy',
    metricTags: [],
    selectedMetricTags: [],
    unselectedMetricTags: ['p1=eth0x', 'p1=eth1x', 'p1=eth2x', 'p1=eth3x', 'p1=eth4x']
  },
  {
    instanceId: '57170f33-ba82-487a-a63b-a86157cb7e60',
    instanceName: 'CG-CS-GAME-40',
    instanceIP: '10.22.2.96',
    region: 'cn-qingyangtest-1',
    metricKey: 'rx.bytes.phy',
    metricTags: [],
    selectedMetricTags: [],
    unselectedMetricTags: ['p1=eth0x', 'p1=eth1x', 'p1=eth2x', 'p1=eth3x', 'p1=eth4x']
  },
  {
    instanceId: 'a9641bc0-d519-4d21-91d7-16643530b91b',
    instanceName: 'CG-CS-GAME-45',
    instanceIP: '10.22.2.56',
    region: 'cn-qingyangtest-1',
    metricKey: 'rx.bytes.phy',
    metricTags: [],
    selectedMetricTags: [],
    unselectedMetricTags: ['p1=eth0x', 'p1=eth1x', 'p1=eth2x', 'p1=eth3x', 'p1=eth4x']
  },
  {
    instanceId: '64d0d488-5b04-4270-b93c-4f3bf4cbe49b',
    instanceName: 'CG-CS-GAME-47',
    instanceIP: '10.22.2.138',
    region: 'cn-qingyangtest-1',
    metricKey: 'rx.bytes.phy',
    metricTags: [],
    selectedMetricTags: [],
    unselectedMetricTags: ['p1=eth0x', 'p1=eth1x', 'p1=eth2x', 'p1=eth3x', 'p1=eth4x']
  },
  {
    instanceId: '19101f46-3e15-4e1c-bc0b-a8eb75b56cd4',
    instanceName: 'CG-CS-GAME-37',
    instanceIP: '10.22.2.118',
    region: 'cn-qingyangtest-1',
    metricKey: 'rx.bytes.phy',
    metricTags: [],
    selectedMetricTags: [],
    unselectedMetricTags: ['p1=eth0x', 'p1=eth1x', 'p1=eth2x', 'p1=eth3x', 'p1=eth4x']
  },
  {
    instanceId: 'f84d0718-b3e3-47eb-9a60-8c79f0e0ebbd',
    instanceName: 'CG-CS-GAME-48',
    instanceIP: '10.22.2.39',
    region: 'cn-qingyangtest-1',
    metricKey: 'rx.bytes.phy',
    metricTags: [],
    selectedMetricTags: [],
    unselectedMetricTags: ['p1=eth0x', 'p1=eth1x', 'p1=eth2x', 'p1=eth3x', 'p1=eth4x']
  },
  {
    instanceId: '07f15abf-2b6a-4b7b-b405-508fa22311a8',
    instanceName: 'CG-CS-GAME-50',
    instanceIP: '10.22.2.51',
    region: 'cn-qingyangtest-1',
    metricKey: 'rx.bytes.phy',
    metricTags: [],
    selectedMetricTags: [],
    unselectedMetricTags: ['p1=eth0x', 'p1=eth1x', 'p1=eth2x', 'p1=eth3x', 'p1=eth4x']
  },
  {
    instanceId: '5bca38d7-05a5-4e35-87df-7c0009727694',
    instanceName: 'CG-CS-GAME-38',
    instanceIP: '10.22.2.148',
    region: 'cn-qingyangtest-1',
    metricKey: 'rx.bytes.phy',
    metricTags: [],
    selectedMetricTags: [],
    unselectedMetricTags: ['p1=eth0x', 'p1=eth1x', 'p1=eth2x', 'p1=eth3x', 'p1=eth4x']
  },
  {
    instanceId: 'ee5f0ff6-4049-46d8-8e66-6c910d988be7',
    instanceName: 'CG-CS-GAME-60',
    instanceIP: '10.22.2.108',
    region: 'cn-qingyangtest-1',
    metricKey: 'rx.bytes.phy',
    metricTags: [],
    selectedMetricTags: [],
    unselectedMetricTags: ['p1=eth0x', 'p1=eth1x', 'p1=eth2x', 'p1=eth3x', 'p1=eth4x']
  },
  {
    instanceId: 'd8efd25b-56dd-4834-b917-4c4c3be7d762',
    instanceName: 'CG-CS-GAME-42',
    instanceIP: '10.22.2.134',
    region: 'cn-qingyangtest-1',
    metricKey: 'rx.bytes.phy',
    metricTags: [],
    selectedMetricTags: [],
    unselectedMetricTags: ['p1=eth0x', 'p1=eth1x', 'p1=eth2x', 'p1=eth3x', 'p1=eth4x']
  },
  {
    instanceId: 'e884bcec-d683-4861-8c6a-dbfad952b5aa',
    instanceName: 'CG-CS-GAME-56',
    instanceIP: '10.22.2.224',
    region: 'cn-qingyangtest-1',
    metricKey: 'rx.bytes.phy',
    metricTags: [],
    selectedMetricTags: [],
    unselectedMetricTags: ['p1=eth0x', 'p1=eth1x', 'p1=eth2x', 'p1=eth3x', 'p1=eth4x']
  },
  {
    instanceId: 'a47ec703-4d95-4704-aec4-de01b951edbe',
    instanceName: 'CG-CS-GAME-41',
    instanceIP: '10.22.2.128',
    region: 'cn-qingyangtest-1',
    metricKey: 'rx.bytes.phy',
    metricTags: [],
    selectedMetricTags: [],
    unselectedMetricTags: ['p1=eth0x', 'p1=eth1x', 'p1=eth2x', 'p1=eth3x', 'p1=eth4x']
  },
  {
    instanceId: 'a5221b80-181c-4569-aec6-a5bc38c2dd55',
    instanceName: 'CG-CS-GAME-52',
    instanceIP: '10.22.2.27',
    region: 'cn-qingyangtest-1',
    metricKey: 'rx.bytes.phy',
    metricTags: [],
    selectedMetricTags: [],
    unselectedMetricTags: ['p1=eth0x', 'p1=eth1x', 'p1=eth2x', 'p1=eth3x', 'p1=eth4x']
  },
  {
    instanceId: '495fe106-6fce-49e2-a1ba-f85056426be3',
    instanceName: 'CG-CS-GAME-61',
    instanceIP: '10.22.2.244',
    region: 'cn-qingyangtest-1',
    metricKey: 'rx.bytes.phy',
    metricTags: [],
    selectedMetricTags: [],
    unselectedMetricTags: ['p1=eth0x', 'p1=eth1x', 'p1=eth2x', 'p1=eth3x', 'p1=eth4x']
  },
  {
    instanceId: 'bd5d3863-551b-4036-aa55-e4854eb2b18b',
    instanceName: 'CG-CS-GAME-64',
    instanceIP: '10.22.2.214',
    region: 'cn-qingyangtest-1',
    metricKey: 'rx.bytes.phy',
    metricTags: [],
    selectedMetricTags: [],
    unselectedMetricTags: ['p1=eth0x', 'p1=eth1x', 'p1=eth2x', 'p1=eth3x', 'p1=eth4x']
  },
  {
    instanceId: 'aca2cd16-4112-4851-8fd8-a34cdf7230d5',
    instanceName: 'CG-CS-GAME-51',
    instanceIP: '10.22.2.24',
    region: 'cn-qingyangtest-1',
    metricKey: 'rx.bytes.phy',
    metricTags: [],
    selectedMetricTags: [],
    unselectedMetricTags: ['p1=eth0x', 'p1=eth1x', 'p1=eth2x', 'p1=eth3x', 'p1=eth4x']
  },
  {
    instanceId: '37cbf95d-765c-40af-af21-f56dac705719',
    instanceName: 'CG-CS-GAME-43',
    instanceIP: '10.22.2.252',
    region: 'cn-qingyangtest-1',
    metricKey: 'rx.bytes.phy',
    metricTags: [],
    selectedMetricTags: [],
    unselectedMetricTags: ['p1=eth0x', 'p1=eth1x', 'p1=eth2x', 'p1=eth3x', 'p1=eth4x']
  },
  {
    instanceId: 'aeeac676-e57c-4167-84b4-d7b421d73e13',
    instanceName: 'CG-CS-GAME-54',
    instanceIP: '10.22.2.161',
    region: 'cn-qingyangtest-1',
    metricKey: 'rx.bytes.phy',
    metricTags: [],
    selectedMetricTags: [],
    unselectedMetricTags: ['p1=eth0x', 'p1=eth1x', 'p1=eth2x', 'p1=eth3x', 'p1=eth4x']
  },
  {
    instanceId: 'c6df1be8-e6eb-4e45-bf16-f40211d7396f',
    instanceName: 'CG-CS-GAME-44',
    instanceIP: '10.22.2.254',
    region: 'cn-qingyangtest-1',
    metricKey: 'rx.bytes.phy',
    metricTags: [],
    selectedMetricTags: [],
    unselectedMetricTags: ['p1=eth0x', 'p1=eth1x', 'p1=eth2x', 'p1=eth3x', 'p1=eth4x']
  },
  {
    instanceId: 'd34637b5-02e4-4f36-a9eb-3bcf5eda23d5',
    instanceName: 'CG-CS-GAME-59',
    instanceIP: '10.22.2.220',
    region: 'cn-qingyangtest-1',
    metricKey: 'rx.bytes.phy',
    metricTags: [],
    selectedMetricTags: [],
    unselectedMetricTags: ['p1=eth0x', 'p1=eth1x', 'p1=eth2x', 'p1=eth3x', 'p1=eth4x']
  },
  {
    instanceId: '533eca5f-34af-4310-a796-90b0796e6464',
    instanceName: 'CG-CS-GAME-46',
    instanceIP: '10.22.2.158',
    region: 'cn-qingyangtest-1',
    metricKey: 'rx.bytes.phy',
    metricTags: [],
    selectedMetricTags: [],
    unselectedMetricTags: ['p1=eth0x', 'p1=eth1x', 'p1=eth2x', 'p1=eth3x', 'p1=eth4x']
  },
  {
    instanceId: 'b3d85efa-e6ed-4f1f-9bbe-11de72fbccbb',
    instanceName: 'CG-CS-GAME-63',
    instanceIP: '10.22.2.202',
    region: 'cn-qingyangtest-1',
    metricKey: 'rx.bytes.phy',
    metricTags: [],
    selectedMetricTags: [],
    unselectedMetricTags: ['p1=eth0x', 'p1=eth1x', 'p1=eth2x', 'p1=eth3x', 'p1=eth4x']
  },
  {
    instanceId: '592b9b52-7a40-42e8-a076-b077308115db',
    instanceName: 'CG-CS-GAME-49',
    instanceIP: '10.22.2.196',
    region: 'cn-qingyangtest-1',
    metricKey: 'rx.bytes.phy',
    metricTags: [],
    selectedMetricTags: [],
    unselectedMetricTags: ['p1=eth0x', 'p1=eth1x', 'p1=eth2x', 'p1=eth3x', 'p1=eth4x']
  },
  {
    instanceId: 'ebcd2316-f7d5-46fb-b0c1-5631d7b73218',
    instanceName: 'CG-CS-GAME-57',
    instanceIP: '10.22.2.47',
    region: 'cn-qingyangtest-1',
    metricKey: 'rx.bytes.phy',
    metricTags: [],
    selectedMetricTags: [],
    unselectedMetricTags: ['p1=eth0x', 'p1=eth1x', 'p1=eth2x', 'p1=eth3x', 'p1=eth4x']
  },
  {
    instanceId: '0229380a-4659-4eb3-85ab-0ea192d0d334',
    instanceName: 'CG-CS-GAME-58',
    instanceIP: '10.22.2.38',
    region: 'cn-qingyangtest-1',
    metricKey: 'rx.bytes.phy',
    metricTags: [],
    selectedMetricTags: [],
    unselectedMetricTags: ['p1=eth0x', 'p1=eth1x', 'p1=eth2x', 'p1=eth3x', 'p1=eth4x']
  },
  {
    instanceId: 'f78cf3ed-fcb7-4338-bc80-47dbd527cf03',
    instanceName: 'CG-CS-GAME-53',
    instanceIP: '10.22.2.89',
    region: 'cn-qingyangtest-1',
    metricKey: 'rx.bytes.phy',
    metricTags: [],
    selectedMetricTags: [],
    unselectedMetricTags: ['p1=eth0x', 'p1=eth1x', 'p1=eth2x', 'p1=eth3x', 'p1=eth4x']
  },
  {
    instanceId: '2125f0c8-8908-46f0-b718-b817302bb814',
    instanceName: 'CG-CS-GAME-62',
    instanceIP: '10.22.2.25',
    region: 'cn-qingyangtest-1',
    metricKey: 'rx.bytes.phy',
    metricTags: [],
    selectedMetricTags: [],
    unselectedMetricTags: ['p1=eth0x', 'p1=eth1x', 'p1=eth2x', 'p1=eth3x', 'p1=eth4x']
  },
  {
    instanceId: '504d67e7-fd47-4e24-a7b7-127bd5bfafd0',
    instanceName: 'epc-public-auto',
    instanceIP: '10.0.19.61',
    region: 'cn-qingyangtest-1',
    metricKey: 'rx.bytes.phy',
    metricTags: [],
    selectedMetricTags: [],
    unselectedMetricTags: ['p1=eth0x', 'p1=eth1x', 'p1=eth2x', 'p1=eth3x', 'p1=eth4x']
  },
  {
    instanceId: '2c9bcbbf-89bb-44c1-8a90-2214f3f04bc4',
    instanceName: 'epc-public-auto',
    instanceIP: '10.0.36.120',
    region: 'cn-qingyangtest-1',
    metricKey: 'rx.bytes.phy',
    metricTags: [],
    selectedMetricTags: [],
    unselectedMetricTags: ['p1=eth0x', 'p1=eth1x', 'p1=eth2x', 'p1=eth3x', 'p1=eth4x']
  },
  {
    instanceId: '46f81e16-e744-417d-9d41-22d108eaa92f',
    instanceName: 'epc-public-auto',
    instanceIP: '10.0.38.112',
    region: 'cn-qingyangtest-1',
    metricKey: 'rx.bytes.phy',
    metricTags: [],
    selectedMetricTags: [],
    unselectedMetricTags: ['p1=eth0x', 'p1=eth1x', 'p1=eth2x', 'p1=eth3x', 'p1=eth4x']
  },
  {
    instanceId: '17304849-a60c-4aac-b249-52de4f1a3659',
    instanceName: 'epc-public-auto',
    instanceIP: '11.0.52.71',
    region: 'cn-qingyangtest-1',
    metricKey: 'rx.bytes.phy',
    metricTags: [],
    selectedMetricTags: [],
    unselectedMetricTags: ['p1=eth0x', 'p1=eth1x', 'p1=eth2x', 'p1=eth3x', 'p1=eth4x']
  },
  {
    instanceId: 'c8d7b9cc-ac38-4ea6-bfb0-c5ca49fc5797',
    instanceName: 'epc-public-auto',
    instanceIP: '11.0.69.253',
    region: 'cn-qingyangtest-1',
    metricKey: 'rx.bytes.phy',
    metricTags: [],
    selectedMetricTags: [],
    unselectedMetricTags: ['p1=eth0x', 'p1=eth1x', 'p1=eth2x', 'p1=eth3x', 'p1=eth4x']
  },
  {
    instanceId: '11718d98-6343-4505-921c-58fd8c4e6263',
    instanceName: 'epc-public-auto',
    instanceIP: '11.0.22.233',
    region: 'cn-qingyangtest-1',
    metricKey: 'rx.bytes.phy',
    metricTags: [],
    selectedMetricTags: [],
    unselectedMetricTags: ['p1=eth0x', 'p1=eth1x', 'p1=eth2x', 'p1=eth3x', 'p1=eth4x']
  },
  {
    instanceId: 'e0384dd8-4d6b-42b2-92f8-fed0520b9614',
    instanceName: 'epc-public-auto',
    instanceIP: '11.0.72.3',
    region: 'cn-qingyangtest-1',
    metricKey: 'rx.bytes.phy',
    metricTags: [],
    selectedMetricTags: [],
    unselectedMetricTags: ['p1=eth0x', 'p1=eth1x', 'p1=eth2x', 'p1=eth3x', 'p1=eth4x']
  },
  {
    instanceId: 'b5a5a6ca-8833-4f5a-8e97-b383addc0ad1',
    instanceName: 'epc-public-auto',
    instanceIP: '11.0.70.62',
    region: 'cn-qingyangtest-1',
    metricKey: 'rx.bytes.phy',
    metricTags: [],
    selectedMetricTags: [],
    unselectedMetricTags: ['p1=eth0x', 'p1=eth1x', 'p1=eth2x', 'p1=eth3x', 'p1=eth4x']
  },
  {
    instanceId: 'aa3bf052-fca6-470e-b0f6-ca76dec05950',
    instanceName: 'epc-public-auto',
    instanceIP: '11.0.66.61',
    region: 'cn-qingyangtest-1',
    metricKey: 'rx.bytes.phy',
    metricTags: [],
    selectedMetricTags: [],
    unselectedMetricTags: ['p1=eth0x', 'p1=eth1x', 'p1=eth2x', 'p1=eth3x', 'p1=eth4x']
  },
  {
    instanceId: 'f3883573-8951-467f-8423-189eb54b8a70',
    instanceName: 'epc-public-auto',
    instanceIP: '11.0.64.192',
    region: 'cn-qingyangtest-1',
    metricKey: 'rx.bytes.phy',
    metricTags: [],
    selectedMetricTags: [],
    unselectedMetricTags: ['p1=eth0x', 'p1=eth1x', 'p1=eth2x', 'p1=eth3x', 'p1=eth4x']
  },
  {
    instanceId: '0537e0d9-5482-44d7-9af7-465004f7b938',
    instanceName: 'A100-2',
    instanceIP: '10.0.1.15',
    region: 'cn-qingyangtest-1',
    metricKey: 'rx.bytes.phy',
    metricTags: [],
    selectedMetricTags: [],
    unselectedMetricTags: ['p1=eth0x', 'p1=eth1x', 'p1=eth2x', 'p1=eth3x', 'p1=eth4x']
  },
  {
    instanceId: 'b1cbebe7-8a0b-4047-aeb1-30cca57e320d',
    instanceName: 'atom-ksyun-3090-69',
    instanceIP: '10.11.11.221',
    region: 'cn-qingyangtest-1',
    metricKey: 'rx.bytes.phy',
    metricTags: [],
    selectedMetricTags: [],
    unselectedMetricTags: ['p1=eth0x', 'p1=eth1x', 'p1=eth2x', 'p1=eth3x', 'p1=eth4x']
  },
  {
    instanceId: '9322e6db-6f61-4826-b963-5c4eedaa66c8',
    instanceName: 'cloudmonitor-test',
    instanceIP: '10.0.8.73',
    region: 'cn-qingyangtest-1',
    metricKey: 'rx.bytes.phy',
    metricTags: [],
    selectedMetricTags: [],
    unselectedMetricTags: ['p1=eth0x', 'p1=eth1x', 'p1=eth2x', 'p1=eth3x', 'p1=eth4x']
  },
  {
    instanceId: '34521245-d846-4b1e-9d72-493116cb9cf7',
    instanceName: 'atom-ksyun-3090-70',
    instanceIP: '10.11.11.218',
    region: 'cn-qingyangtest-1',
    metricKey: 'rx.bytes.phy',
    metricTags: [],
    selectedMetricTags: [],
    unselectedMetricTags: ['p1=eth0x', 'p1=eth1x', 'p1=eth2x', 'p1=eth3x', 'p1=eth4x']
  }
]
const TestPage = () => {
  const [formValues, setFormValues] = useState<any>({ productType: '' })

  // 获取支持自定义面板的产品线
  const { value: productList } = useAsync(async () => {
    const result = await request(ApiCommon.getProudctGroup, {})
    if (result.code === 'Success') {
      return result?.data?.categories || []
    }
  }, [])

  return (
    <Form>
      <div>
        <FormItem
          value={formValues.productType}
          slotLabel={
            <FormItemLabelToopltip
              label="监控项"
              tips="请选择产品类型和监控项，定义展示在图表中的数据"
            />
          }
        >
          <FormItem
            hideLabel
            value={formValues.productType}
            rules={{
              required: true
            }}
          >
            <ProductGroupSelect
              value={formValues.productType}
              width={300}
              placeholder="请选择产品类型"
              productList={productList || []}
              onChange={value => {
                setFormValues({
                  productType: value
                })
              }}
            />
          </FormItem>
        </FormItem>
      </div>
    </Form>
  )
}
export default TestPage
